import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Select from '../../../form/Select'
import Button from '../../../../UniformComponents/Button'
import SelfSelectRules from './SelfSelectRules'
import Questions from './Questions'
import Flags from './Flags'
import Panel from '../../../../UniformComponents/Panel'

@observer
class CreateEdit extends Component {
    constructor(props) {
        super(props)
        const { store, certificationId } = this.props
        store.initEdit(parseInt(certificationId, 10))
    }

    componentDidMount() {
        const { store } = this.props
        store.appStore.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'certification',
                url: '/intranet/certification',
                title: 'Certification',
            },
        ]
    }

    renderField = (field) => {
        const { store } = this.props
        const { formData } = store
        const { onChange } = store
        const {
            type,
            options,
            name,
            promise,
            fieldResets,
            path,
            label,
            key,
        } = field

        switch (type) {
            case 'select':
                return (
                    <Select
                        label={label}
                        name={name}
                        key={key}
                        options={options()}
                        defaultValue={R.pathOr(undefined, path, formData)}
                        onBlur={(obj) => onChange(obj, promise, path, fieldResets)}
                    />
                )
            case 'questions':
                return (
                    <Questions store={store} />
                )
            case 'flags':
                return (
                    <Flags store={store} />
                )
            case 'selfSelect':
                return (
                    <SelfSelectRules store={store} />
                )
            default:
                return null
        }
    }

    render() {
        const { store } = this.props
        const { isLoading, getForm } = store

        return (
            <div id="certification">
                <Panel>
                    {!isLoading && (
                        getForm().map(this.renderField)
                    )}
                    <div
                        style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <Button
                            label="Save"
                            onClick={store.save}
                            disabled={store.saveIsDisabled()}
                            cssClass="regular primary"
                        />
                    </div>
                </Panel>
            </div>
        )
    }
}

export default CreateEdit
